// import React, { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import wish from "../images/wishlist_nofill.svg";
// import wishlist from "../images/wish.svg";
// import { useWishlist } from "../Context/WishlistContext";
// import { useCart } from "../Context/Createcontext";
// import { Helmet } from "react-helmet";
// import ReactPaginate from "react-paginate";
// import Popup from "../Components/common/Popup";
// import { api_url } from "../config/config";
// import { useNavigate } from "react-router-dom";
// import cart from "../images/cart.svg";
// import addToCartIcon from "../Icons/addToCartIcon.svg";
// import { toast } from "react-toastify";
// import { useApp } from "../Context/AppContext";
// import loader from "../images/loaderimg.png";
// const Allproducts = () => {
//   const { isInWishlist, addToWishlist, removeFromWishlist } = useWishlist();
//   const {
//     handleAddToCart,
//     showLoginPopup,
//     setShowLoginPopup,
//     handleRemoveFromCart,
//     cartItems,
//     setCartItems,
//   } = useCart();
//   const { contextCategories, contextBrands } = useApp()
//   const [selectedCategories, setSelectedCategories] = useState(new Set());
//   const [showCategories, setShowCategories] = useState(false);
//   const [showBrands, setShowBrands] = useState(false);
//   const [products, setProducts] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [brands, setBrands] = useState([]); // State to hold brands
//   const [error, setError] = useState([]);
//   const [catid, setCatid] = useState([]);
//   const [manufactid, setManufactid] = useState([]);
//   const [filteredBrands, setFilteredBrands] = useState([]); // State for filtered brands
//   const [selectedBrands, setSelectedBrands] = useState(new Set()); // Set for selected brands
//   const [searchTerm, setSearchTerm] = useState(""); // Search term
//   const [sortOrder, setSortOrder] = useState("low-to-high");
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [dropdownOpenBrands, setDropdownOpenBrands] = useState(false);
//   const [dropdownOpenSort, setDropdownOpenSort] = useState(false);
//   const [showMobileCategories, setShowMobileCategories] = useState(false);
//   const [showMobileBrands, setShowMobileBrands] = useState(false);
//   const [showMobileSort, setShowMobileSort] = useState(false);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(0);
//   const productsPerPage = 20; // Adjust as needed

//   const navigate = useNavigate();
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowMobileCategories(false);
//         setShowMobileBrands(false);
//         setShowMobileSort(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//         const formattedBrands = contextBrands.map((brand) => ({
//           id: brand.manufacturer_id,
//           name: brand.name,
//         }));

//         setBrands(formattedBrands);
//         setFilteredBrands(formattedBrands);
//   }, [contextBrands]);

//   useEffect(() => {
//     if (searchTerm.trim() === "") {
//       setFilteredBrands(brands);
//     } else {
//       const filtered = brands.filter((brand) =>
//         brand.name.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredBrands(filtered);
//     }
//   }, [searchTerm, brands]);

//   // Handle category selection
//   const handleCategoryChange = (categoryId) => {
//     setSelectedCategories((prevSelected) => {
//       const updatedSelected = new Set(prevSelected);
//       if (updatedSelected.has(categoryId)) {
//         updatedSelected.delete(categoryId);
//       } else {
//         updatedSelected.add(categoryId);
//       }
//       return updatedSelected;
//     });

//     setCurrentPage(0);
//     // fetchAllProducts();

//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   // Filter selected category products
//   useEffect(() => {

//     if (selectedCategories.size === 0) {
//       setFilteredProducts(products);
//     } else {
//       const filtered = products.filter((product) =>
//         product.category_ids.some((cat) =>
//           selectedCategories.has(cat.category_id)
//         )
//       );

//       setFilteredProducts(filtered);
//     }
//   }, [selectedCategories, products]);

//   useEffect(() => {
//   fetchAllProducts();
// }, [selectedCategories, sortOrder, manufactid]);

//   const handleSearch = (e) => {
//     const term = e.target.value.toLowerCase();
//     setSearchTerm(term);
//     setFilteredBrands(
//       brands.filter(
//         (brand) =>
//           brand.brand_name && brand.brand_name.toLowerCase().includes(term)
//       )
//     );
//   };
//   const handleCheckboxChange = (brandId, e) => {
//     setSelectedBrands((prevSelectedBrands) => {
//       const updatedSelectedBrands = new Set(prevSelectedBrands);
//       e.target.checked
//         ? updatedSelectedBrands.add(brandId)
//         : updatedSelectedBrands.delete(brandId);
//       return updatedSelectedBrands;
//     });

//     setManufactid((prevState) => {
//       const updatedManufactid = e.target.checked
//         ? [...prevState, brandId]
//         : prevState.filter((id) => id !== brandId);

//       setCurrentPage(0);

//       if (updatedManufactid.length > 0) {
//         fetchFilteredProducts(updatedManufactid);
//       } else {
//         setFilteredProducts([]);
//       }

//       return updatedManufactid;
//     });

//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };
//   const fetchFilteredProducts = async (selectedBrands) => {
//     setLoading(true);
//     try {
//       const url = `${api_url}/all-product?page=1&limit=100`;

//       const requestBody = {
//         manufacturer_ids: selectedBrands,
//         category_ids: selectedCategories,
//       };

//       const response = await axios.post(url, requestBody, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           "x-auth": "false",
//         },
//       });

//       const data = response.data;

//       if (Array.isArray(data.data)) {
//         setProducts(data.data);
//         setFilteredProducts(data.data);
//       } else {
//         setProducts([]);
//         setFilteredProducts([]);
//       }
//     } catch (error) {
//       console.error(
//         "Error fetching filtered products:",
//         error.response?.data || error.message
//       );
//       setFilteredProducts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // sidebar fetch
//   // useEffect(() => {
//   //   const fetchProducts = async () => {
//   //     try {
//   //       const response = await fetch(
//   //         ` ${api_url}/categories?page=1&limit=2000 `
//   //       );
//   //       const data = await response.json();

//   //       const products = data.results || [];
//   //       const uniqueCategories = [
//   //         ...new Set(
//   //           products.map((product) => product.category_name || "Uncategorized")
//   //         ),
//   //       ];
//   //       setCategories(products);

//   //     } catch (error) {
//   //       console.error("Failed to fetch products:", error);
//   //       setFilteredProducts([]); // Handle error by setting an empty array
//   //     }
//   //   };
//   //   fetchProducts();
//   // }, []);
//   const handleclickforfeaturedproduct = (product_id, product) => {

//     navigate(`/products/${product.name?.toLowerCase().replace(/\s+/g, "-")}`, {
//       state: { product_id },
//     });
//   };
//   const handleSortChange = async (order) => {

//     setSortOrder(order);

//     if (!products.length) return;

//     // switch (order) {
//     //   case "low-to-high":
//     //     sortedProducts.sort(
//     //       (a, b) =>
//     //         (a.variant?.[0]?.discounted_price ?? a.variant?.[0]?.price ?? 0) -
//     //         (b.variant?.[0]?.discounted_price ?? b.variant?.[0]?.price ?? 0)
//     //     );
//     //     break;
//     //   case "high-to-low":
//     //     sortedProducts.sort(
//     //       (a, b) =>
//     //         (b.variant?.[0]?.discounted_price ?? b.variant?.[0]?.price ?? 0) -
//     //         (a.variant?.[0]?.discounted_price ?? a.variant?.[0]?.price ?? 0)
//     //     );
//     //     break;
//     //   case "discount":
//     //     sortedProducts.sort(
//     //       (a, b) => (b.discount_percent ?? 0) - (a.discount_percent ?? 0)
//     //     );
//     //     break;
//     //   default:
//     //     break;
//     // }
//       const requestBody = {
//         category_ids: Array.isArray(catid) ? catid : [catid],
//         manufacturer_ids: Array.isArray(manufactid) ? manufactid : [],
//       };
//      const response = await axios.post(`${api_url}/all-product?page=1&limit=100&sort=${order}`, requestBody);

//     setProducts(response.data.data);
//     setCurrentPage(0);
//   };

//   const HandlenewCategory = async (category_id) => {
//     setCatid(category_id);
//   };

//   const HandlenewManufact = (manufacturer_id, e) => {
//     setSelectedBrands((prevSelectedBrands) => {
//       const updatedSelectedBrands = new Set(prevSelectedBrands);

//       if (e.target.checked) {
//         updatedSelectedBrands.add(manufacturer_id);
//       } else {
//         updatedSelectedBrands.delete(manufacturer_id);
//       }

//       return new Set(updatedSelectedBrands);
//     });

//     setManufactid((prev) => {
//       let updatedManufactid;
//       if (e.target.checked) {
//         updatedManufactid = [...prev, manufacturer_id];
//       } else {
//         updatedManufactid = prev.filter((p) => p !== manufacturer_id);
//       }

//       setCurrentPage(0); // ✅ Reset to first page when filtering
//       fetchAllProducts(updatedManufactid); // ✅ Fetch products based on new filter
//       return updatedManufactid;
//     });
//   };

//   const fetchAllProducts = async () => {
//     setLoading(true);
//     try {
//       const url = `${api_url}/all-product?page=1&limit=100&sort=${sortOrder}`;
//       const requestBody = {
//         category_ids:  [...selectedCategories],
//         manufacturer_ids: Array.isArray(manufactid) ? manufactid : [],
//       };
//       const response = await axios.post(url, requestBody, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           "x-auth": "false",
//         },
//       });

//       const data = response.data;

//       if (Array.isArray(data.data)) {
//         setProducts(data.data);
//         setFilteredProducts(data.data);
//       } else {
//         setProducts([]);
//         setFilteredProducts([]);
//       }
//     } catch (error) {
//       console.error(
//         "Failed to fetch products by category:",
//         error.response?.data || error.message
//       );
//       setFilteredProducts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllProducts();
//   }, [manufactid]);

//   // Pagination Logic
//   const pageCount = Math.ceil(filteredProducts.length / productsPerPage);
//   const currentProducts = filteredProducts.slice(
//     currentPage * productsPerPage,
//     (currentPage + 1) * productsPerPage
//   );

//   const handlePageChange = ({ selected }) => {
//     setCurrentPage(selected);

//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };
//   const handleClearAll = () => {
//     setSelectedBrands(new Set());
//     setManufactid([]);
//     setCatid([]);

//     localStorage.removeItem("category_id");
//     localStorage.removeItem("category_name");
//     setFilteredProducts([]);

//     fetchAllProducts();
//   };

//   const handleIncrease = async (event, variant, item) => {
//     event.preventDefault();
//     try {
//       if (!variant || !variant.variant_id) {
//         console.error("❌ Invalid variant data in handleIncrease");
//         return;
//       }
//       const quantity = await getCartQuantity(variant.variant_id);

//       const cartResponse = await fetch(`${api_url}/cart`, {
//         method: "PATCH",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//         },
//         body: JSON.stringify({
//           product_id: variant.product_id,
//           quantity: quantity + 1,
//           variant_id: variant.variant_id,
//         }),
//       });

//       const responseData = await cartResponse.json();

//       if (
//         !cartResponse.ok ||
//         responseData.message?.toLowerCase().includes("stock not available")
//       ) {
//         toast.error(`${item.name} is out of stock`);
//         return;
//       }
//       setCartItems(prev =>
//         prev.map(ci =>
//           ci.variant_id === variant.variant_id
//             ? { ...ci, quantity: ci.quantity + 1 }
//             : ci
//         )
//       );
//     } catch (err) {
//       console.log(err);
//       toast.error(`Something went wrong`);
//     }
//   };

//   const handleDecrease = async (event, variant) => {
//     event.preventDefault();
//     try {
//       if (!variant || !variant.variant_id) {
//         return;
//       }
//       const quantity = await getCartQuantity(variant.variant_id);
//       if (quantity === 1) {
//         const cartResponse = await handleRemoveFromCart(
//           variant.product_id,
//           variant.variant_id
//         );
//         setCartItems(prev =>
//               quantity === 1
//                 ? prev.filter(ci => ci.variant_id !== variant.variant_id)
//                 : prev.map(ci =>
//                     ci.variant_id === variant.variant_id
//                       ? { ...ci, quantity: ci.quantity - 1 }
//                       : ci
//                   )
//             );
//         return;
//       }
//       const cartResponse = await fetch(`${api_url}/cart`, {
//         method: "PATCH",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//         },
//         body: JSON.stringify({
//           product_id: variant.product_id,
//           quantity: quantity - 1,
//           variant_id: variant.variant_id,
//         }),
//       });

//       const responseData = await cartResponse.json();

//       if (
//         !cartResponse.ok ||
//         responseData.message?.toLowerCase().includes("stock not available")
//       ) {
//         toast.error(`Something went wrong`);
//         return;
//       }
//      setCartItems(prev =>
//          quantity === 1
//          ? prev.filter(ci => ci.variant_id !== variant.variant_id)
//              : prev.map(ci =>
//               ci.variant_id === variant.variant_id
//                 ? { ...ci, quantity: ci.quantity - 1 }
//                   : ci
//             )
//        );
//     } catch (err) {
//       console.log(err);
//       toast.error(`Something went wrong`);
//     }
//   };
//   const getCartQuantity = (variantId) => {

//     const item = cartItems.find((ci) => ci.variant_id === variantId);
//     return item ? item.quantity : 0;
//   };
//     const OutOfQuantityCheck = (variants) => {
//       return variants.every((v) => v.quantity === 0);
//     };

//   useEffect(() => {
//     // fetchCartProducts();
//     window.scrollTo(0, 0);
//   }, []);

//   return (
//     <div>
//       <Helmet>
//         <title>
//           All Products | Online Medical Store, Online Medicine Order, Fastest
//           Delivery | MediSYS Pharmacy
//         </title>
//         <meta
//           name="description"
//           content="MediSYS Pharmacy Online Medical Store - Online Medicine Order - Buy medicines online from MediSYS Pharmacy Store  and experience the fastest home delivery. All kinds of medicines, health products and equipment are available at our online medicine store."
//         />
//         <meta
//           name="keywords"
//           content="pharmacy, medical stores, online pharmacy, online pharmacy India, best online pharmacy, online pharmacy hyderabad, online medical store, online medicine store, online medical shop, online medical store hyderabad"
//         />
//         <meta name="robots" content="index, follow" />
//         <meta
//           property="og:title"
//           content="Online Medical Store, Online Medicine Order, Fastest Delivery | MediSYS Pharmacy"
//         />
//         <meta
//           property="og:description"
//           content="MediSYS Pharmacy Online Medical Store - Online Medicine Order - Buy medicines online from MediSYS Pharmacy Store  and experience the fastest home delivery. All kinds of medicines, health products and equipment are available at our online medicine store."
//         />
//       </Helmet>
//       {/* Breadcrumb */}

//       <div className="flex flex-col md:flex-row py-10 justify-between xl:px-16 md:px-4">
//         <div className="relative font-poppins text-[#1a1a1a] font-semibold leading-[30px] border-2 border-white">
//           <ul className=" flex items-center list-none p-0 m-0">
//             <li className="ml-2 lg:text-[20px] lg:leading-7 text-sm text-[#1a1a1a] font-poppins">
//               <a href="/home">Home</a>
//             </li>
//             <li className="ml-2 lg:text-2xl">&gt;</li>
//             <li className="ml-2 lg:text-[20px] lg:leading-7 text-sm text-[#1a1a1a] font-poppins">
//               All Products
//             </li>
//           </ul>
//         </div>
//         <div className=" md:block lg:absolute hidden md:flex-col  flex-col  space-y-4 sm:space-y-0 sm:space-x-4 md:space-x-1  md:space-y-0  right-10 ">
//           <span className="  text-base cursor-pointer font-normal w-[58px] font-poppins text-[#1a1a1a]">
//             Sort By:
//           </span>

//           <button
//             className={`h-[27px] w-[100px] rounded-md font-poppins font-normal text-base text-[#162C2A] border-2 border-[#162c2a] ${
//               sortOrder === "low-to-high" ? "bg-blue-100" : ""
//             }`}
//             onClick={() => handleSortChange("low-to-high")}
//           >
//             Low to High
//           </button>
//           <button
//             className={`lg:h-[27px] lg:w-[100px] md:h-[27px] md:w-[130px] rounded-md font-poppins font-normal text-base text-[#162C2A] border-2 border-[#162c2a] ${
//               sortOrder === "high-to-low" ? "bg-blue-100" : ""
//             }`}
//             onClick={() => handleSortChange("high-to-low")}
//           >
//             High to Low
//           </button>
//           <button
//             className={`h-[27px] w-[100px] rounded-md font-poppins font-normal text-base text-[#162C2A] border-2 border-[#162c2a] ${
//               sortOrder === "discount" ? "bg-blue-100" : ""
//             }`}
//             onClick={() => handleSortChange("discount")}
//           >
//             Discount
//           </button>
//         </div>
//       </div>

//       <div className="flex flex-col md:flex-row justify-center items-start -mt-[80px]">
//         {/* Sidebar */}
//         <aside
//           ref={dropdownRef}
//           className="lg:w-[310px] md:w-[250px] p-6 bg-white mt-[20px] lg:mt-[40px]
//         md:mt-[40px]"
//         >
//           {/* Mobile Buttons for Categories, Brands, and Sort (Only for Mobile) */}
//           <div className="flex justify-between items-center gap-2 sm:hidden mb-4 mt-[20px]">
//             <button
//               className={`flex-1 border border-gray-400 text-black px-4 py-2 rounded-md text-sm font-semibold ${
//                 showMobileCategories
//                   ? "bg-[#162c2a] text-white"
//                   : "bg-transparent"
//               }`}
//               onClick={() => {
//                 setShowMobileCategories(!showMobileCategories);
//                 setShowMobileBrands(false);
//                 setShowMobileSort(false);
//               }}
//             >
//               Categories
//             </button>
//             <button
//               className={`flex-1 border border-gray-400 text-black px-4 py-2 rounded-md text-sm font-semibold ${
//                 showMobileBrands ? "bg-[#162c2a] text-white" : "bg-transparent"
//               }`}
//               onClick={() => {
//                 setShowMobileBrands(!showMobileBrands);
//                 setShowMobileCategories(false);
//                 setShowMobileSort(false);
//               }}
//             >
//               Brands
//             </button>
//             <button
//               className={`flex-1 border border-gray-400 text-black px-4 py-2 rounded-md text-sm font-semibold ${
//                 showMobileSort ? "bg-[#162c2a] text-white" : "bg-transparent"
//               }`}
//               onClick={() => {
//                 setShowMobileSort(!showMobileSort);
//                 setShowMobileCategories(false);
//                 setShowMobileBrands(false);
//               }}
//             >
//               Sort
//             </button>
//           </div>

//           {/* Categories Section */}
//           {(showMobileCategories || window.innerWidth > 700) && (
//             <div className="w-full bg-white shadow-md mb-6">
//               <div className="px-4 py-6 border border-gray-300 rounded-md h-auto">
//                 <div className="text-lg font-semibold mb-4">Category</div>
//                 <div className="space-y-2">
//                   {contextCategories.map((category) => (
//                     <div
//                       key={category.category_id}
//                       className="flex items-start gap-2"
//                     >
//                       <input
//                         id={`category-${category.category_id}`}
//                         type="checkbox"
//                         checked={selectedCategories.has(category.category_id)}
//                         onChange={(e) =>
//                           handleCategoryChange(category.category_id, e)
//                         }
//                         className="form-checkbox h-4 w-4 text-blue-600 mt-1 flex-shrink-0"
//                       />
//                       <label className=" font-poppins text-[16px] text-gray-600 leading-snug break-words"  htmlFor={`category-${category.category_id}`}>
//                         {category.category_name}
//                       </label>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Brands Section */}
//           {(showMobileBrands || window.innerWidth > 700) && (
//             <div className="w-full bg-white shadow-md">
//               <div className="px-4 py-6">
//                 <div className="flex justify-between items-center mb-4">
//                   <div className="text-lg font-semibold">Brands</div>
//                   <button
//                     className="text-blue-500 hover:underline text-sm"
//                     onClick={handleClearAll}
//                   >
//                     Clear All
//                   </button>
//                 </div>

//                 <div className="relative mb-4">
//                   <input
//                     type="text"
//                     placeholder="Search"
//                     value={searchTerm}
//                     onChange={handleSearch}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
//                   />
//                 </div>

//                 <div className="space-y-2 overflow-y-auto h-96 border border-gray-300 rounded-md p-2">
//                   {error && <div className="text-red-500">{error}</div>}

//                    {contextBrands.length > 0 && filteredBrands.length === 0 ? (
//                       <div className="text-gray-500">No brands found.</div>
//                     ) : (
//                     filteredBrands.map((brand) => (
//                       <div key={brand.id} className="flex items-start gap-2">
//                         <input
//                           id={`brand-${brand.id}`}
//                           type="checkbox"
//                           checked={selectedBrands.has(brand.id)}
//                           onChange={(e) => handleCheckboxChange(brand.id, e)}
//                           className="form-checkbox h-4 w-4 text-blue-600 mt-1 flex-shrink-0"
//                         />
//                         <label
//                           className="font-poppins text-[16px] text-gray-600 leading-snug break-words cursor-pointer" htmlFor={`brand-${brand.id}`}
//                           // onClick={(e) => handleCheckboxChange(brand.id, e)}
//                         >
//                           {brand.name}
//                         </label>
//                       </div>
//                     ))
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Sort Section (Mobile Only) */}
//           {showMobileSort && (
//             <div className="mt-4 bg-white p-4 shadow-md border border-gray-300 rounded-md">
//               <span className="text-base font-semibold block mb-2">
//                 Sort By:
//               </span>
//               <button
//                 className={`block w-full py-2 text-left border-b border-gray-300 ${
//                   sortOrder === "low-to-high" ? "bg-blue-100" : ""
//                 }`}
//                 onClick={() => handleSortChange("low-to-high")}
//               >
//                 Low to High
//               </button>
//               <button
//                 className={`block w-full py-2 text-left border-b border-gray-300 ${
//                   sortOrder === "high-to-low" ? "bg-blue-100" : ""
//                 }`}
//                 onClick={() => handleSortChange("high-to-low")}
//               >
//                 High to Low
//               </button>
//               <button
//                 className={`block w-full py-2 text-left ${
//                   sortOrder === "discount" ? "bg-blue-100" : ""
//                 }`}
//                 onClick={() => handleSortChange("discount")}
//               >
//                 Discount
//               </button>
//             </div>
//           )}
//         </aside>

//         {/* Main Content */}
//         <div className="w-full md:w-3/4 p-6">
//           {/* Product Grid */}
//           <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-6 gap-3 lg:mt-10 mt-[1px] md:mt-[40px] min-h-[200px] flex justify-center items-center">
//             {loading ? (
//               <div className="flex justify-center items-center col-span-full">
//                 <img src={loader} alt="Loading..." className="h-18 w-18 animate-pulse" />
//               </div>
//             ) : filteredProducts.length === 0 ? (
//               <p className="text-center text-gray-500 w-full col-span-full">
//                 No Products Found
//               </p>
//             ) : (
//               currentProducts.map((product, index) => {
//                 const variants = product.variant || [];

//                 const displayVariant = variants.reduce(
//                   (prev, curr) =>
//                     curr.price < prev.price ? curr : prev,
//                   variants[0] || { price: 0, discounted_price: 0 }
//                 );

//                 const originalPrice = displayVariant.price;
//                 const discountedPrice = displayVariant.discounted_price;
//                 const discountPercent = product.discount_percent || 0;

//                 return (
//                   <>
//                     <div className="border p-4 rounded shadow hover:shadow-lg flex flex-col items-center relative">
//                       <Link
//   to="#"
//   onClick={(e) => {
//     e.preventDefault();
//     handleclickforfeaturedproduct(product.product_id, product);
//   }}
//   key={index}
// >

//   <span className="group absolute top-3 left-2">
//   <img
//     src={isInWishlist(product.product_id) ? wishlist : wish}
//     alt={isInWishlist(product.product_id) ? "Wishlisted" : "Wishlist"}
//     className="lg:w-5 lg:h-5 w-4 h-4 cursor-pointer"
//     onClick={e => {
//   e.preventDefault();
//   e.stopPropagation();
//   const isToken = localStorage.getItem('authToken');
//   if (!isToken) {
//     setShowLoginPopup(true);
//     return;
//   }
//   if (isInWishlist(product.product_id)) {
//     removeFromWishlist(product.product_id, product.variant?.[0]?.variant_id);
//   } else {
//     addToWishlist(product, product.variant[0]);
//   }
// }}
//   />
//   <span className="absolute left-7 top-1 z-20 scale-0 group-hover:scale-100 transition-all bg-gray-900 text-white text-xs rounded px-2 py-1 whitespace-nowrap shadow-lg">
//     {isInWishlist(product.product_id) ? 'Remove from wishlist' : 'Add to wishlist'}
//   </span>
// </span>
//   {discountPercent > 0 && (
//     <div className="absolute top-2 right-2 bg-red-500 text-white text-xs font-semibold w-10 h-10 flex items-center pl-[8px] rounded-full z-10">
//       {discountPercent}% OFF
//     </div>
//   )}
//   <div className="w-full flex justify-start items-center h-40">
//     <img
//       src={
//         product?.product_images?.image_url?.primary_image ||
//         "https://via.placeholder.com/150"
//       }
//       alt={product.name || "Category Image"}
//       onError={(e) => {
//         e.target.onerror = null;
//         e.target.src = "/default.svg";
//       }}
//       className="max-w-full max-h-full object-contain transition-transform duration-300 hover:scale-105"
//     />
//   </div>
//   <div className="w-full h-[2rem] mt-3 flex items-start ">
//     <h2 className="text-sm sm:text-base font-semibold text-left w-full max-w-full overflow-hidden line-clamp-2 text-ellipsis break-words">
//       {product.name || "Unnamed Product"}
//     </h2>
//   </div>
//   <div className="w-full h-[2rem] flex items-center gap-2 text-sm font-normal text-[#1A1A1A] font-inter">
//     {discountPercent > 0 && (
//       <div className="text-xs text-gray-500 line-through">
//         ₹{originalPrice}
//       </div>
//     )}
//     <div className="font-bold">₹{discountedPrice}</div>
//   </div>
//   <div className="h-5">
//     {OutOfQuantityCheck(variants) && (
//       <div>
//         <p className="text-xs text-red-500 font-semibold">Out of Stock</p>
//       </div>
//     )}
//   </div>
// </Link>
//                       {Array.isArray(product.variant) && product.variant.length > 1 ? (
//                         <button
//                           className="bg-[#162c2a] hover:bg-green-600 transition-all disabled:hover:none disabled:bg-gray-500 text-[11px] font-[300] md:text-[12px] md:font-[300] lg:text-[16px] lg:font-[500] font-poppins sm:text-base w-full h-10 text-white rounded-md flex items-center justify-center gap-2"
//                           onClick={(event) => {
//                             event.preventDefault();
//                             event.stopPropagation();
//                             const isToken = localStorage.getItem('authToken');
//                             if (!isToken) {
//                               setShowLoginPopup(true);
//                               return;
//                             }
//                             handleclickforfeaturedproduct(product.product_id, product);
//                           }}
//                           type="button"
//                         >
//                           <img src={addToCartIcon} alt="Cart" className="w-[14px] h-[14px] lg:w-[15px] lg:h-[18px] object-contain" />
//                           Add to Cart
//                         </button>
//                       ) : getCartQuantity(product.variant[0]?.variant_id) > 0 ? (
//                         <div className="flex items-center justify-between border-2 border-black rounded-xl lg:px-4 gap-2 sm:gap-5 w-full mx-auto">
//                           <button
//                             className="px-2 sm:px-3 py-1 text-lg sm:text-xl text-black cursor-pointer"
//                             onClick={(event) =>
//                               handleDecrease(event, product.variant[0], product)
//                             }
//                             type="button"
//                           >
//                             -
//                           </button>
//                           <span className="text-base sm:text-lg font-bold text-black min-w-[20px] text-center">
//                             {getCartQuantity(product.variant[0]?.variant_id)}
//                           </span>
//                           <button
//                             className="px-2 sm:px-3 py-1 text-lg sm:text-xl text-black cursor-pointer"
//                             onClick={(event) =>
//                               handleIncrease(event, product.variant[0], product)
//                             }
//                             type="button"
//                           >
//                             +
//                           </button>
//                         </div>
//                       ) : (
//                         <button
//                           className="bg-[#162c2a] hover:bg-green-600 transition-all  disabled:hover:none disabled:bg-gray-500 text-[11px] font-[300] md:text-[12px] md:font-[300] lg:text-[16px] lg:font-[500] font-poppins sm:text-base w-full h-10 text-white  rounded-md  flex items-center justify-center gap-2"
//                           onClick={async (event) => {
//                             event.preventDefault();
//                             event.stopPropagation();
//                             const isToken = localStorage.getItem('authToken');
//                             if (!isToken) {
//                               setShowLoginPopup(true);
//                               return;
//                             }
//                             await handleAddToCart(
//                               product,
//                               product.variant[0],
//                               1
//                             );
//                           }}
//                           disabled={OutOfQuantityCheck(variants)}
//                         >
//                           <img
//                             src={addToCartIcon}
//                             alt="Cart"
//                             className="w-[14px] h-[14px] lg:w-[15px] lg:h-[18px] object-contain"
//                           />
//                           Add to Cart
//                         </button>
//                       )}

//                       {showLoginPopup && (
//                         <Popup onClose={() => setShowLoginPopup(false)} />
//                       )}
//                     </div>
//                   </>
//                 );
//               })
//             )}
//           </div>

//           {/* Pagination */}
//           {pageCount > 1 && (
//             <div className="mt-6 flex justify-center w-full overflow-x-auto">
//               <ReactPaginate
//                 previousLabel="Previous"
//                 nextLabel="Next"
//                 breakLabel="..."
//                 pageCount={pageCount}
//                 marginPagesDisplayed={1}
//                 pageRangeDisplayed={2}
//                 onPageChange={handlePageChange}
//                 containerClassName="flex items-center space-x-2 border rounded-lg p-2 md:p-3 lg:p-4 w-full max-w-md justify-center md:justify-between"
//                 pageClassName="border rounded-md px-2 py-1 md:px-3 md:py-2 cursor-pointer text-xs md:text-sm lg:text-base"
//                 activeClassName="bg-[#162c2a] text-white border-black"
//                 previousClassName="border px-2 py-1 md:px-3 md:py-2 rounded-md cursor-pointer bg-[#162c2a] text-white text-xs md:text-sm"
//                 nextClassName="border px-2 py-1 md:px-3 md:py-2 rounded-md cursor-pointer bg-[#162c2a] text-white text-xs md:text-sm"
//                 disabledClassName="opacity-50 cursor-not-allowed"
//               />
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Allproducts;

import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import wish from "../images/wishlist_nofill.svg";
import wishFilled from "../images/wish.svg";
import { useWishlist } from "../Context/WishlistContext";
import { useCart } from "../Context/Createcontext";
import { Helmet } from "react-helmet";
import ReactPaginate from "react-paginate";
import Popup from "../Components/common/Popup";
import { api_url } from "../config/config";
import { useNavigate } from "react-router-dom";
import addToCartIcon from "../Icons/addToCartIcon.svg";
import { toast } from "react-toastify";
import { useApp } from "../Context/AppContext";
import loader from "../images/loaderimg.png";
import HeroSection from "./HeroBannner";

const SORT_OPTIONS = [
  { value: "low-to-high", label: "Price: Low → High" },
  { value: "high-to-low", label: "Price: High → Low" },
  { value: "discount", label: "Best Discount" },
];

/* ── Sort Dropdown ── */
const SortDropdown = ({ sortOrder, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current =
    SORT_OPTIONS.find((o) => o.value === sortOrder) || SORT_OPTIONS[0];
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((p) => !p)}
        className="flex items-center gap-2 bg-white border border-[#e2eaea] hover:border-[#5fbdb3] text-[#374747] text-[13px] font-semibold px-4 h-10 rounded-xl transition-all duration-200 font-poppins whitespace-nowrap"
      >
        <svg
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="4" y1="6" x2="20" y2="6" />
          <line x1="8" y1="12" x2="16" y2="12" />
          <line x1="11" y1="18" x2="13" y2="18" />
        </svg>
        Sort: {current.label}
        <svg
          className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`}
          width="11"
          height="11"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1.5 z-50 bg-white border border-[#e2eaea] rounded-2xl shadow-[0_8px_32px_rgba(22,44,42,0.16)] overflow-hidden min-w-[200px]">
          {SORT_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              className={`w-full flex items-center justify-between px-4 py-3 text-[13px] font-semibold text-left transition-all font-poppins ${sortOrder === opt.value ? "bg-[#eaf4f3] text-[#1e4a46]" : "text-[#374747] hover:bg-[#f8fafa] hover:text-[#1e4a46]"}`}
            >
              {opt.label}
              {sortOrder === opt.value && (
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#1e4a46"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const AllProductsIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#5fbdb3"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="3" width="20" height="5" rx="1" />
    <rect x="2" y="10" width="20" height="5" rx="1" />
    <rect x="2" y="17" width="20" height="5" rx="1" />
  </svg>
);

const Allproducts = () => {
  const { isInWishlist, addToWishlist, removeFromWishlist } = useWishlist();
  const {
    handleAddToCart,
    showLoginPopup,
    setShowLoginPopup,
    handleRemoveFromCart,
    cartItems,
    setCartItems,
  } = useCart();
  const { contextCategories, contextBrands } = useApp();

  const [selectedCategories, setSelectedCategories] = useState(new Set());
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState(new Set());
  const [searchTerm, setSearchTerm] = useState("");
  const [heroSearch, setHeroSearch] = useState("");
  const [brandSearch, setBrandSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("low-to-high");
  const [catid, setCatid] = useState([]);
  const [manufactid, setManufactid] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(null);

  const navigate = useNavigate();
  const productsPerPage = 20;
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setSidebarOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    const formatted = contextBrands.map((b) => ({
      id: b.manufacturer_id,
      name: b.manufacturer_name,
    }));
    setBrands(formatted);
    setFilteredBrands(formatted);
  }, [contextBrands]);

  useEffect(() => {
    if (!brandSearch.trim()) {
      setFilteredBrands(brands);
      return;
    }
    setFilteredBrands(
      brands.filter((b) =>
        b.name.toLowerCase().includes(brandSearch.toLowerCase()),
      ),
    );
  }, [brandSearch, brands]);

  useEffect(() => {
    if (selectedCategories.size === 0) {
      setFilteredProducts(products);
      return;
    }
    setFilteredProducts(
      products.filter((p) =>
        p.category_ids?.some((c) => selectedCategories.has(c.category_id)),
      ),
    );
  }, [selectedCategories, products]);

  /* live search */
  useEffect(() => {
    if (!heroSearch.trim()) {
      if (selectedCategories.size === 0) {
        setFilteredProducts(products);
        return;
      }
      setFilteredProducts(
        products.filter((p) =>
          p.category_ids?.some((c) => selectedCategories.has(c.category_id)),
        ),
      );
      return;
    }
    const base =
      selectedCategories.size === 0
        ? products
        : products.filter((p) =>
            p.category_ids?.some((c) => selectedCategories.has(c.category_id)),
          );
    setFilteredProducts(
      base.filter((p) =>
        p.name?.toLowerCase().includes(heroSearch.toLowerCase()),
      ),
    );
    setCurrentPage(0);
  }, [heroSearch, products, selectedCategories]);

  const fetchAllProducts = async (overrideManufact) => {
    setLoading(true);
    try {
      const mids =
        overrideManufact !== undefined ? overrideManufact : manufactid;
      const res = await axios.post(
        `${api_url}/all-product?page=1&limit=100&sort=${sortOrder}`,
        {
          category_ids: [...selectedCategories],
          manufacturer_ids: Array.isArray(mids) ? mids : [],
        },
        { headers: { "Content-Type": "application/json", "x-auth": "false" } },
      );
      const data = Array.isArray(res.data.data) ? res.data.data : [];
      setProducts(data);
      setFilteredProducts(data);
    } catch {
      setProducts([]);
      setFilteredProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllProducts();
  }, [manufactid, selectedCategories, sortOrder]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSortChange = (order) => {
    setSortOrder(order);
    setCurrentPage(0);
  };

  const handleCategoryChange = (categoryId) => {
    setSelectedCategories((prev) => {
      const n = new Set(prev);
      n.has(categoryId) ? n.delete(categoryId) : n.add(categoryId);
      return n;
    });
    setCurrentPage(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCheckboxChange = (brandId, checked) => {
    setSelectedBrands((prev) => {
      const n = new Set(prev);
      checked ? n.add(brandId) : n.delete(brandId);
      return n;
    });
    setManufactid((prev) => {
      const n = checked
        ? [...prev, brandId]
        : prev.filter((id) => id !== brandId);
      setCurrentPage(0);
      return n;
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleClearAll = () => {
    setSelectedBrands(new Set());
    setManufactid([]);
    setCatid([]);
    setSelectedCategories(new Set());
    setHeroSearch("");
    setFilteredProducts([]);
    fetchAllProducts([]);
  };

  const handleProductClick = (product_id, product) =>
    navigate(`/products/${product.name?.toLowerCase().replace(/\s+/g, "-")}`, {
      state: { product_id },
    });

  const OutOfQuantityCheck = (variants) =>
    variants.every((v) => v.quantity === 0);

  const getCartQuantity = (variantId) => {
    const item = cartItems.find((ci) => ci.variant_id === variantId);
    return item ? item.quantity : 0;
  };

  const handleIncrease = async (e, variant, item) => {
    e.preventDefault();
    if (!variant?.variant_id) return;
    const qty = getCartQuantity(variant.variant_id);
    const res = await fetch(`${api_url}/cart`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: JSON.stringify({
        product_id: variant.product_id,
        quantity: qty + 1,
        variant_id: variant.variant_id,
      }),
    });
    const data = await res.json();
    if (
      !res.ok ||
      data.message?.toLowerCase().includes("stock not available")
    ) {
      toast.error(`${item.name} is out of stock`);
      return;
    }
    setCartItems((prev) =>
      prev.map((ci) =>
        ci.variant_id === variant.variant_id
          ? { ...ci, quantity: ci.quantity + 1 }
          : ci,
      ),
    );
  };

  const handleDecrease = async (e, variant) => {
    e.preventDefault();
    if (!variant?.variant_id) return;
    const qty = getCartQuantity(variant.variant_id);
    if (qty === 1) {
      await handleRemoveFromCart(variant.product_id, variant.variant_id);
      setCartItems((prev) =>
        prev.filter((ci) => ci.variant_id !== variant.variant_id),
      );
      return;
    }
    const res = await fetch(`${api_url}/cart`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: JSON.stringify({
        product_id: variant.product_id,
        quantity: qty - 1,
        variant_id: variant.variant_id,
      }),
    });
    const data = await res.json();
    if (
      !res.ok ||
      data.message?.toLowerCase().includes("stock not available")
    ) {
      toast.error("Something went wrong");
      return;
    }
    setCartItems((prev) =>
      prev.map((ci) =>
        ci.variant_id === variant.variant_id
          ? { ...ci, quantity: ci.quantity - 1 }
          : ci,
      ),
    );
  };

  const offset = currentPage * productsPerPage;
  const currentProducts = filteredProducts.slice(
    offset,
    offset + productsPerPage,
  );
  const pageCount = Math.ceil(filteredProducts.length / productsPerPage);

  return (
    <div className="min-h-screen bg-[#f8fafa] font-poppins">
      <Helmet>
        <title>All Products | MediSYS Pharmacy</title>
        <meta
          name="description"
          content="MediSYS Pharmacy - Buy medicines online with fastest home delivery."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <HeroSection
        breadcrumbs={[
          { label: "Home", to: "/home" },
          { label: "All Products" },
        ]}
        title="All Products"
        subtitle={
          !loading
            ? `${filteredProducts.length} product${filteredProducts.length !== 1 ? "s" : ""} available`
            : "Loading products…"
        }
        badge="Our Collection"
        icon={<AllProductsIcon />}
        accentColor="#5fbdb3"
      />

      {/* Search + Sort bar */}
      <div className="bg-white border-b border-[#e2eaea] px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
          <div className="flex items-center gap-2.5 flex-1 bg-[#f8fafa] border border-[#e2eaea] focus-within:border-[#5fbdb3] focus-within:bg-white rounded-xl px-4 h-10 transition-all duration-200">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#8faba9"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="flex-shrink-0"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              value={heroSearch}
              onChange={(e) => setHeroSearch(e.target.value)}
              placeholder="Search products…"
              className="flex-1 bg-transparent outline-none text-[13px] font-medium text-[#1e4a46] placeholder-[#8faba9] font-poppins"
            />
            {heroSearch && (
              <button
                onClick={() => setHeroSearch("")}
                className="text-[#8faba9] hover:text-[#1e4a46] transition-colors"
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            )}
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="lg:hidden flex items-center gap-2 text-[13px] font-semibold text-[#1e4a46] border border-[#d4ecea] bg-[#eaf4f3] px-4 h-10 rounded-xl"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="4" y1="6" x2="20" y2="6" />
                <line x1="8" y1="12" x2="20" y2="12" />
                <line x1="12" y1="18" x2="20" y2="18" />
              </svg>
              Filter
              {selectedBrands.size + selectedCategories.size > 0 && (
                <span className="bg-[#ff601e] text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
                  {selectedBrands.size + selectedCategories.size}
                </span>
              )}
            </button>
            <SortDropdown sortOrder={sortOrder} onChange={handleSortChange} />
            {!loading && (
              <div className="hidden sm:flex items-center gap-1.5 bg-[#eaf4f3] border border-[#d4ecea] rounded-xl px-3 h-10 flex-shrink-0">
                <span className="font-bold text-[13px] text-[#1e4a46]">
                  {filteredProducts.length}
                </span>
                <span className="text-[12px] text-[#5fbdb3] font-medium">
                  products
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row">
        {/* Sidebar */}
        <aside
          ref={dropdownRef}
          className={`${sidebarOpen ? "block" : "hidden"} lg:block lg:w-[260px] xl:w-[280px] flex-shrink-0 bg-white border-r border-[#e2eaea]`}
        >
          <div className="sticky top-0 p-5 space-y-6 max-h-[calc(100vh-120px)] overflow-y-auto">
            {/* Categories */}
            <div>
              <h3 className="font-bold text-[14px] px-4 text-[#ff601e]  mb-3">
                Categories
              </h3>
              <div className="flex flex-col gap-1">
                {contextCategories.map((cat) => {
                  const checked = selectedCategories.has(cat.category_id);
                  return (
                    <label
                      key={cat.category_id}
                      className={`flex items-center gap-2.5 px-3 py-2.5 rounded-xl cursor-pointer transition-all ${checked ? "bg-[#eaf4f3] border border-[#d4ecea]" : "hover:bg-[#f8fafa] border border-transparent"}`}
                    >
                      <div
                        onClick={() => handleCategoryChange(cat.category_id)}
                        className={`w-4 h-4 rounded-md border-[1.5px] flex items-center justify-center flex-shrink-0 transition-all ${checked ? "bg-[#1e4a46] border-[#1e4a46]" : "border-[#c5d5d4] bg-white"}`}
                      >
                        {checked && (
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        )}
                      </div>
                      <span
                        className={`text-[12px] ${checked ? "font-semibold text-[#1e4a46]" : "text-[#374747]"}`}
                      >
                        {cat.category_name}
                      </span>
                    </label>
                  );
                })}
              </div>
            </div>

            <div className="h-px bg-[#f1f5f5]" />

            {/* Brands */}
            <div className="px-3">
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-bold text-[14px] text-[#ff601e]">Brands</h3>
                {selectedBrands.size > 0 && (
                  <button
                    onClick={handleClearAll}
                    className="text-[11px] font-semibold text-[#ff601e] hover:underline"
                  >
                    Clear ({selectedBrands.size})
                  </button>
                )}
              </div>
              <div className="flex items-center gap-2 bg-[#f8fafa] border border-[#e2eaea] rounded-xl px-3 h-9 mb-3 focus-within:border-[#1e4a46] transition-all">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#8faba9"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                <input
                  type="text"
                  placeholder="Search brands…"
                  value={brandSearch}
                  onChange={(e) => setBrandSearch(e.target.value)}
                  className="flex-1 bg-transparent outline-none text-[12px] text-[#1a2625] placeholder-[#8faba9]"
                />
              </div>
              <div className="flex flex-col gap-1 max-h-[260px] overflow-y-auto pr-1 scrollbar-hide">
                {filteredBrands.map((brand) => {
                  const checked = selectedBrands.has(brand.id);
                  return (
                    <label
                      key={brand.id}
                      className={`flex items-center gap-2.5 px-1 py-2.5 rounded-xl cursor-pointer transition-all ${checked ? "bg-[#eaf4f3] border border-[#d4ecea]" : "hover:bg-[#f8fafa] border border-transparent"}`}
                    >
                      <div
                        onClick={() => handleCheckboxChange(brand.id, !checked)}
                        className={`w-4 h-4 rounded-md border-[1.5px] flex items-center justify-center flex-shrink-0 transition-all ${checked ? "bg-[#1e4a46] border-[#1e4a46]" : "border-[#c5d5d4] bg-white"}`}
                      >
                        {checked && (
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        )}
                      </div>
                      <span
                        className={`text-[12px] ${checked ? "font-semibold text-[#1e4a46]" : "text-[#374747]"}`}
                      >
                        {brand.name}
                      </span>
                    </label>
                  );
                })}
                {filteredBrands.length === 0 && (
                  <p className="text-[12px] text-[#8faba9] px-2 py-3">
                    No brands found.
                  </p>
                )}
              </div>
            </div>
          </div>
        </aside>
        {/* Products grid */}
        <div className="flex-1 px-4 sm:px-6 lg:px-8 py-6">
          {loading ? (
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4">
              {Array.from({ length: 8 }).map((_, i) => (
                <div
                  key={i}
                  className="bg-white rounded-2xl border border-[#e2eaea] overflow-hidden animate-pulse flex flex-col"
                >
                  <div className="h-[160px] bg-[#e2eaea]" />
                  <div className="p-3 flex flex-col gap-2">
                    <div className="h-3 bg-[#e2eaea] rounded-full w-3/4" />
                    <div className="h-3 bg-[#e2eaea] rounded-full w-1/2" />
                    <div className="h-9 bg-[#e2eaea] rounded-xl mt-1" />
                  </div>
                </div>
              ))}
            </div>
          ) : currentProducts.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 gap-4">
              <div className="w-16 h-16 rounded-2xl bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#5fbdb3"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <path d="M16 10a4 4 0 0 1-8 0" />
                </svg>
              </div>
              <p className="font-semibold text-[15px] text-[#374747]">
                No products found
              </p>
              <p className="text-[13px] text-[#8faba9]">
                Try changing your filters or search term.
              </p>
              <button
                onClick={handleClearAll}
                className="flex items-center gap-2 bg-[#1e4a46] hover:bg-[#162c2a] text-white font-semibold text-[13px] px-5 h-9 rounded-xl transition-all"
              >
                Clear all filters
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4">
              {currentProducts.map((product, index) => {
                const variants = product.variant || [];
                const minVariant = variants.reduce(
                  (min, v) => (v.price < min.price ? v : min),
                  variants[0] || { price: 0, discounted_price: 0 },
                );
                const originalPrice = minVariant?.price || 0;
                const discountedPrice =
                  minVariant?.discounted_price || originalPrice;
                const discountPercent =
                  originalPrice > 0
                    ? Math.round(
                        ((originalPrice - discountedPrice) / originalPrice) *
                          100,
                      )
                    : 0;
                const isWishlisted = isInWishlist(product.product_id);
                const isOutOfStock = OutOfQuantityCheck(variants);
                const cartQty = getCartQuantity(product.variant[0]?.variant_id);
                const isMultiVariant =
                  Array.isArray(product.variant) && product.variant.length > 1;
                const isOrange = index % 2 === 1;
                const cardBg = isOrange
                  ? "bg-gradient-to-b from-[#fff3ee] to-white"
                  : "bg-gradient-to-b from-[#eaf4f3] to-white";
                const cardBorder = isOrange
                  ? "border-[#ffd5c2] hover:border-[#ff601e]/60"
                  : "border-[#e2eaea] hover:border-[#5fbdb3]";
                const accentBar = isOrange
                  ? "from-[#ff601e] to-[#e55519]"
                  : "from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]";
                const imgBg = isOrange ? "bg-[#fff8f5]" : "bg-[#f4fbfa]";
                const shadow = isOrange
                  ? "shadow-[0_2px_12px_rgba(255,96,30,0.09)] hover:shadow-[0_10px_28px_rgba(255,96,30,0.22)]"
                  : "shadow-[0_2px_12px_rgba(95,189,179,0.09)] hover:shadow-[0_10px_28px_rgba(95,189,179,0.22)]";
                const btnCls = isOrange
                  ? "bg-[#ff601e] hover:bg-[#e55519] shadow-[0_2px_8px_rgba(255,96,30,0.3)]"
                  : "bg-[#1e4a46] hover:bg-[#ff601e] shadow-[0_2px_8px_rgba(22,44,42,0.2)] hover:shadow-[0_4px_14px_rgba(255,96,30,0.4)]";

                return (
                  <div
                    key={index}
                    className={`group border-[1.5px] ${cardBorder} ${cardBg} ${shadow} rounded-2xl overflow-hidden flex flex-col relative hover:-translate-y-2 transition-all duration-300 cursor-pointer`}
                    style={{
                      animation: `fadeInUp 0.35s ease ${(index % 8) * 40}ms both`,
                    }}
                  >
                    <div
                      className={`absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r ${accentBar} opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10`}
                    />
                    {discountPercent > 0 && (
                      <div className="absolute top-3 right-3 z-10 bg-[#ff601e] text-white text-[9px] sm:text-[10px] font-bold w-9 h-9 rounded-full flex flex-col items-center justify-center shadow-[0_2px_8px_rgba(255,96,30,0.45)] leading-tight text-center">
                        {discountPercent}%<br />
                        OFF
                      </div>
                    )}
                    <button
                      className="absolute top-3 left-3 z-10 w-7 h-7 sm:w-8 sm:h-8 bg-white rounded-xl border border-[#e2eaea] flex items-center justify-center shadow-sm hover:border-[#5fbdb3] hover:bg-[#eaf4f3] transition-all duration-200"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!localStorage.getItem("authToken")) {
                          setShowLoginPopup(true);
                          return;
                        }
                        isWishlisted
                          ? removeFromWishlist(
                              product.product_id,
                              product.variant?.[0]?.variant_id,
                            )
                          : addToWishlist(product, product.variant?.[0]);
                      }}
                      onMouseEnter={() => setTooltipOpen(index)}
                      onMouseLeave={() => setTooltipOpen(null)}
                    >
                      <img
                        src={isWishlisted ? wishFilled : wish}
                        alt="wishlist"
                        className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                      />
                      {tooltipOpen === index && (
                        <div className="absolute left-9 top-0 bg-[#162c2a] text-white text-[10px] font-medium px-2 py-1 rounded-lg whitespace-nowrap shadow z-30">
                          {isWishlisted
                            ? "Remove from wishlist"
                            : "Add to wishlist"}
                        </div>
                      )}
                    </button>
                    <div
                      className={`w-full h-[150px] sm:h-[170px] lg:h-[190px] ${imgBg} flex items-center justify-center overflow-hidden pt-6 pb-2 cursor-pointer`}
                      onClick={() =>
                        handleProductClick(product.product_id, product)
                      }
                    >
                      <img
                        src={
                          product?.product_images?.image_url?.primary_image ||
                          "/default.svg"
                        }
                        alt={product.name || "Product"}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/default.svg";
                        }}
                        className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <div className="w-full h-px bg-[#f1f5f5]" />
                    <div
                      className="px-3 sm:px-4 pt-3 pb-2 flex-1 flex flex-col gap-1.5 cursor-pointer"
                      onClick={() =>
                        handleProductClick(product.product_id, product)
                      }
                    >
                      <h3 className="font-semibold text-[12px] sm:text-[13px] text-[#1e4a46] line-clamp-2 leading-snug group-hover:text-[#ff601e] transition-colors duration-200">
                        {product.name || "Unnamed Product"}
                      </h3>
                      <div className="flex items-baseline gap-2">
                        {discountPercent > 0 && (
                          <span className="text-[11px] text-[#8faba9] line-through">
                            ₹{originalPrice}
                          </span>
                        )}
                        <span className="font-bold text-[14px] sm:text-[15px] text-[#1e4a46]">
                          ₹{discountedPrice}
                        </span>
                        {discountPercent > 0 && (
                          <span
                            className={`text-[10px] font-semibold ${isOrange ? "text-[#ff601e]" : "text-[#5fbdb3]"}`}
                          >
                            {discountPercent}% off
                          </span>
                        )}
                      </div>
                      {isOutOfStock && (
                        <span className="self-start text-[10px] font-semibold text-red-500 bg-red-50 border border-red-100 rounded-lg px-2 py-0.5">
                          Out of Stock
                        </span>
                      )}
                    </div>
                    <div className="px-3 sm:px-4 pb-4 pt-1">
                      {isMultiVariant ? (
                        <button
                          className={`w-full h-10 ${btnCls} text-white text-[11px] sm:text-[12px] font-semibold rounded-xl flex items-center justify-center gap-1.5 transition-all duration-200 disabled:bg-[#c5d5d4] disabled:cursor-not-allowed`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!localStorage.getItem("authToken")) {
                              setShowLoginPopup(true);
                              return;
                            }
                            handleProductClick(product.product_id, product);
                          }}
                          disabled={isOutOfStock}
                        >
                          <img
                            src={addToCartIcon}
                            alt="Cart"
                            className="w-3.5 h-3.5 object-contain"
                          />
                          Choose Variant
                        </button>
                      ) : cartQty > 0 ? (
                        <div className="flex items-center justify-between bg-[#eaf4f3] border border-[#d4ecea] rounded-xl h-10 px-3">
                          <button
                            onClick={(e) =>
                              handleDecrease(e, product.variant[0], product)
                            }
                            className="w-7 h-7 flex items-center justify-center text-[#1e4a46] font-bold text-xl hover:bg-white rounded-lg transition-colors"
                          >
                            −
                          </button>
                          <span className="font-bold text-[14px] text-[#1e4a46] min-w-[24px] text-center">
                            {cartQty}
                          </span>
                          <button
                            onClick={(e) =>
                              handleIncrease(e, product.variant[0], product)
                            }
                            className="w-7 h-7 flex items-center justify-center text-[#1e4a46] font-bold text-xl hover:bg-white rounded-lg transition-colors"
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <button
                          className={`w-full h-10 ${btnCls} disabled:bg-[#c5d5d4] disabled:cursor-not-allowed text-white text-[11px] sm:text-[12px] font-semibold rounded-xl flex items-center justify-center gap-1.5 transition-all duration-200`}
                          onClick={async (e) => {
                            e.stopPropagation();
                            if (!localStorage.getItem("authToken")) {
                              setShowLoginPopup(true);
                              return;
                            }
                            await handleAddToCart(
                              product,
                              product.variant[0],
                              1,
                            );
                          }}
                          disabled={isOutOfStock}
                        >
                          <img
                            src={addToCartIcon}
                            alt="Cart"
                            className="w-3.5 h-3.5 object-contain"
                          />
                          {isOutOfStock ? "Out of Stock" : "Add to Cart"}
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {pageCount > 1 && (
            <div className="flex justify-center mt-8">
              <ReactPaginate
                previousLabel={
                  <span className="flex items-center gap-1">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M19 12H5M12 5l-7 7 7 7" />
                    </svg>
                    Prev
                  </span>
                }
                nextLabel={
                  <span className="flex items-center gap-1">
                    Next
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </span>
                }
                breakLabel="…"
                pageCount={pageCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                onPageChange={({ selected }) => {
                  setCurrentPage(selected);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                containerClassName="flex items-center gap-2 flex-wrap justify-center"
                pageClassName="w-9 h-9 rounded-xl border-[1.5px] border-[#e2eaea] bg-white text-[#374747] flex items-center justify-center text-[13px] font-semibold hover:bg-[#eaf4f3] hover:border-[#5fbdb3] cursor-pointer transition-all"
                activeClassName="!bg-[#1e4a46] !border-[#1e4a46] !text-white shadow-[0_2px_8px_rgba(22,44,42,0.25)]"
                previousClassName="flex items-center gap-1 h-9 px-3 rounded-xl border-[1.5px] border-[#e2eaea] bg-white text-[#374747] text-[12px] font-semibold hover:bg-[#eaf4f3] hover:border-[#5fbdb3] cursor-pointer transition-all"
                nextClassName="flex items-center gap-1 h-9 px-3 rounded-xl border-[1.5px] border-[#e2eaea] bg-white text-[#374747] text-[12px] font-semibold hover:bg-[#eaf4f3] hover:border-[#5fbdb3] cursor-pointer transition-all"
                disabledClassName="opacity-40 cursor-not-allowed hover:bg-white hover:border-[#e2eaea]"
                breakClassName="text-[#8faba9] text-[13px] px-1 flex items-center"
              />
            </div>
          )}
        </div>
      </div>

      {showLoginPopup && <Popup onClose={() => setShowLoginPopup(false)} />}
      <style>{`@keyframes fadeInUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </div>
  );
};

export default Allproducts;
